import update from 'react/lib/update';

const initialState = {
	isFetching: false,
	terms: []
};
// TODO: atualizar o ftpTREE quando enviar o arquivo no cadastrar documento
export default function tree(state = initialState, action) {
	switch (action.type) {

		case "IS_FETCHING_TREE":
			return update(state, { isFetching: { $set: action.bool } });

		case "SET_TREE":
			return update(state, { tree: { $set: action.tree } });

		case "SET_TERMS":
			return update(state, { terms: { $set: action.terms } });

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/state/ftp/reducer.js